import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-anteriores-scpc',
  templateUrl: './consulta-anteriores-scpc.component.html',
  styleUrls: ['./consulta-anteriores-scpc.component.scss']
})
export class ConsultaAnterioresScpcComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
  //  this.inverteData(this.consulta.registros);
  }

  inverteData(params) {
    if(params.length > 0) {

      params.map(c => {
        let result;

        let s = c.data.split("");
        
        if(s.length == 8) {
          let formato = {
            day: s[6] + s[7],
            month: s[4] + s[5],
            year: s[0] + s[1] + s[2] + s[3]
          };
          result = formato.day + '/' + formato.month + '/' + formato.year;
        }

        if(s.length == 10) {
          let formato = {
            day: s[8] + s[9],
            month: s[5] + s[6],
            year: s[0] + s[1] + s[2] + s[3]
          };
          result = formato.day + '/' + formato.month + '/' + formato.year;
        }

        if(result && result != null && result.length == 10) {
          c.data = result;
        }else {
          c.data = c.data;
        }

      });

    }

  }

}
